module.exports = __webpack_public_path__ + "img/70026.a6f4fcc9.png";